export function fmt(n: number | null | undefined): string {
  if (n == null) return '0₮';
  return new Intl.NumberFormat('mn-MN').format(n) + '₮';
}

export function num(n: number | null | undefined, digits = 2): string {
  if (n == null) return '0';
  return new Intl.NumberFormat('mn-MN', { maximumFractionDigits: digits }).format(n);
}

export function dt(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('mn-MN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function dateOnly(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('mn-MN', { year: 'numeric', month: '2-digit', day: '2-digit' });
}
